import React, { useState, useEffect, useRef } from 'react';
import percentIcon from '../../assets/valentinesDay/percent.png';

const TOTAL_MS = 3 * 60 * 1000; // 3 minutes

const CountdownTimer = ({ isAuth = false }) => {
  const [remaining, setRemaining] = useState(TOTAL_MS);
  const startTimeRef = useRef(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      const elapsed = Date.now() - startTimeRef.current;
      const left = Math.max(0, TOTAL_MS - elapsed);
      setRemaining(left);
      if (left <= 0) clearInterval(interval);
    }, 37); // ~27fps for smooth ms display

    return () => clearInterval(interval);
  }, []);

  const minutes = Math.floor(remaining / 60000);
  const seconds = Math.floor((remaining % 60000) / 1000);
  const milliseconds = Math.floor((remaining % 1000) / 10);

  const pad2 = (n) => String(n).padStart(2, '0');

  return (
    <div className={`valentines-countdown ${isAuth && 'pink-bg'}`}>
      <img
        src={percentIcon}
        alt=""
        className="countdown-badge"
        aria-hidden="true"
      />
      <span className="countdown-time">
        <span className="time-part">{pad2(minutes)}</span>:
        <span className="time-part"> {pad2(seconds)}</span>:
        <span className="time-part"> {pad2(milliseconds)}</span>
      </span>
    </div>
  );
};

export default CountdownTimer;
